<footer class="flex flex-col place-content-between place-items-center gap-6">
  <sheba-best-hospital [bestHospitalBannerDescription]="footerData()?.bestHospitalBannerDescription"
    [bestHospitalBannerTitle]="footerData()?.bestHospitalBannerTitle" />

  <sheba-email-signup-form class="md:hidden" [footerData]="footerData()" />

  <div class="contents w-full max-w-7xl place-content-between px-4 lg:flex lg:gap-24 xl:px-[6.5rem]">
    <div class="mb-[5.5rem] contents w-full flex-1 md:flex md:px-9 lg:px-0">
      <sheba-navigation [navigation]="footerData().menu" />
    </div>

    <div class="mb-[5.5rem] hidden flex-col gap-16 md:flex">
      <sheba-email-signup-form [footerData]="footerData()" />

      <div class="flex flex-col place-items-center gap-6 lg:place-items-start">
        <sheba-social-media-links [links]="footerData().followUs" />

        <sheba-app-links [appStoreLink]="footerData().appStoreLink" [googleLink]="footerData().googlePlayLink" />
      </div>
    </div>
  </div>

  <div class="contents w-full  justify-between md:flex">
    <sheba-logo-link class="max-md:hidden" [footerData]="footerData()" />

    <sheba-footer-links [termsOfUseLink]="footerData().termsOfUseLink" [sitesPolicyLink]="footerData().sitesPolicyLink"
      [allRightsReservedLink]="footerData().allRightsReservedLink"
      [accessibilityStatementLink]="footerData().accessibilityStatementLink" />

    <sheba-logo-link class="md:hidden" [footerData]="footerData()" />

    <div class="me-[8.125rem] flex gap-4 max-md:hidden">
      @if (footerData().icon1; as img) {
        @if (img!.image) {
        <a [href]="footerData().icon1Link?.url ?? footerData().icon1Link?.route?.path"
          [attr.target]="footerData().icon1Link?.target" [attr.aria-description]="footerData().icon1Link?.title"
          [title]="footerData().icon1Link?.title"
          [shebaGtmClick]="{ user_action: 'user_clicks_footer' }"
          routerLinkDetector>
          <img class="h-[4.375rem] w-[4.375rem]" alt="{{ 'FOOTER.HIGH_QUALITY_ACCRETION_LOGO' | translate }}"
            [ngSrc]="img.image.url | cmsMediaPrefix" [attr.alt]="img?.alt ?? ''" [attr.title]="img?.title ?? ''" width="100" height="100" />
        </a>
        }
      }
      @if (footerData().icon2 && footerData().icon2!.image) {
      <a [href]="footerData().icon2Link?.url ?? footerData().icon2Link?.route?.path"
        [attr.target]="footerData().icon2Link?.target" [attr.aria-description]="footerData().icon2Link?.title"
        [title]="footerData().icon2Link?.title"
        routerLinkDetector>
        <img class="h-[4.375rem] w-[4.375rem]" alt="{{ 'FOOTER.BUTTERFLY_LOGO' | translate }}"
          [ngSrc]="footerData().icon2.image.url | cmsMediaPrefix" [alt]="footerData().icon2.alt ?? ''"
          [attr.title]="footerData().icon2.title ?? ''" height="100" width="100" />
      </a>
      }
    </div>
  </div>

  <div class="flex flex-col place-items-center gap-6 md:hidden">
    <sheba-social-media-links [links]="footerData().followUs" />

    <sheba-app-links [appStoreLink]="footerData().appStoreLink" [googleLink]="footerData().googlePlayLink" />
  </div>

  <!-- <sheba-site-by /> -->
</footer>